function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st1{fill:#1877F2;}\n\t.st0{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "XMLID_17_"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_22_",
  className: "st0",
  d: "M512,256C512,114.6,397.4,0,256,0S0,114.6,0,256c0,127.8,93.6,233.7,216,252.9V330.1h-64.9V256   H216v-56.4c0-64.1,38.2-99.6,96.6-99.6c28.1,0,57.4,5,57.4,5v63h-32.3c-31.8,0-41.7,19.8-41.7,40v48h71l-11.4,74.1h-59.6v178.8   C418.4,489.7,512,383.8,512,256z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_18_",
  className: "st1",
  d: "M355.6,330.1L367,256h-71v-48c0-20.2,10-40,41.7-40h32.3v-63c0,0-29.3-5-57.4-5   c-58.5,0-96.6,35.5-96.6,99.6V256h-64.9v74.1h64.9v178.8c13,2.1,26.4,3.1,40,3.1c13.6,0,26.9-1.1,40-3.1V330.1H355.6z"
}));

var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook.c7d32010.svg";
export { ForwardRef as ReactComponent };